import { BaseRequest } from '../../../app/shared/models/base-request.model';
import { Status } from './general.model';
import { SailDirection } from '../../front-user/shared/models/sail-direction.model';
import { Attachment } from '../../front-user/shared/models/attachment.model';
import { AttachmentType } from 'src/app/shared/models/enums.model';

export class ReleaseOpject {
  Id:string;
  LongHaulRequestOptions: LongHaulRequestOption[];
  PrincipalName: string;
  VesselTypeId: number;
  RequestorId:string;
  BaseRequestRequestNumber: string;
  BaseRequestRequestId: string;
  ReleaseRefundRequestId: string;
  ReleaseRestudyRequestId: string;
  IMONo: string;
  ModifiedBy:string;
  RebateFileNumber: string;
  PrincipalEmail: string;
  PrincipalFax: string;
  VesselName: string;
  BaseRequest: BaseRequest;
  DWT: string;
  SCNT: string;
  TransitSCNT: string;
  TransitDWT: string;
  AcceptDataRateId: number;
  Actualvoyage:number;
  TransitDate:Date;
  //TransitDate:Date;
  DateofLastAgentCorrespondence:Date;
  DatesOfReceivingLastAgentCorrespondence:Date;
  DateOfLastReceivedDocuments:Date;
  DocumnetedSailingDate:Date;
  DocumnetedArrivalDate:Date;
  VoyageCertificatesDestinationPort: string;
  VoyageCertificatesOriginPort: string;
  AISOriginPort: string;
  AISDestinationPort: string;
  Remarks: string;
  AISSailingDate: Date;
  AISArrivalDate: Date;
  ExtraCost: string;
  Transitagent:string;
  TransitagentEmail:string;
  TransitagentFax:string
  InvoiceNo:string
  Currency:number;
  ActualRebateAmount:string;
  DiffAmount:string;
  FormulateDecisionDate: Date;
  RebatePercentage: string;
  DestinationPort: string;
  OriginPort: string;
  TransitRateId:number;
  CreationDate: Date;
  ModifiedDate: Date;
  BaseRequestCreationDate: Date;
  IsShipLoaded: boolean;
  RequestorName: string;
  RequestorFax: string;
  RequestorEmail: string;
 // Remarks: string;
  TransitRebatePercentage: string;
  ActualRebatePercentage: string;
  RebateAmountAsPerInvoice: string;
  Stoppages: Stoppage[];
  ReleaseFormAttachment:ReleaseFormAttachment[]= [];
  SelectedReason:string;
  ReleaseFormDecisionNote:string;
  transitAgentName:string;
  ExceptionNote:string;
  CircularName:string;
  IsCircular: boolean;
  IsException: boolean;
}
export class Stoppage {
  PortName: string;
  Reason: string;
  StartDate: string;
  EndDate: string;
  TYPE: string;
}

export class ReleaseFormAttachment{

    Id:number;
    URL:string;
    ReleaseFormId:string;
    DocumentName:string;
    ReleaseForm: ReleaseOpject;
    AttachmentType:AttachmentType
    file?: File;
    AttachmentTypeId:number;
}
export class ReleaseFormStartWFDTO
{
  ReleaseRequestId: string;
  AdminEmail: string;
  // AdminId: string;
  WFToTerminate: string;
  diffAmount:string;
  IsWFExists: boolean;
  ActualRebateAmount:string;
  RebateAmountAsPerInvoice:string;
  ActualRebatePercentage: string;
  ExistWF: string;
  WFNextUsers: string[];
  Reason:string;
  note:string
}

export class ReleaseRestudyRequestDTO {
  Id: string; // Guid
  ReleaseRequestId: string; // Guid
  MeasReviewerDecision?: number;
  MeasReviewerNotes?: string;
  MeasReviewer2Decision?: number;
  MeasReviewer2Notes?: string;
  MeasManagerDecision?: number;
  MeasManagerNotes?: string;
  EunitRegistersDecision?: number;
  EunitRegisterNotes?: string;
  EunitModifyRebateNote?: string;
  EunitSignedUsersCount?: number;
  MeasCreatorCancelationFromula?: string;
  MeasManagerCanceledRbateNote?: string;
  MeasReviewerCanceledRbateNote?:string;
  MeasReviewerCanceledRbateDecision?: number;
  MeasManagerCanceledRbateDecision?: number;
  EunitApproveDecision?: number;
  EunitApproveNotes?: string;
  DeputyManagerSigned?: number;
  ManagerSigned?: number;
  EunitSignedUsersNo?:number;

  IsDeleted: boolean;
  BaseRequest?: BaseRequest;
}
export class ReleaseRefundRequestDTO {
  Id: string; // Guid
  ReleaseRequestId: string; // Guid
  ReleaseRestudyRequestId: string;
  MeasReviewer1Decision?: number;
  MeasReviewer1Notes?: string;
  MeasReviewer2Decision?: number;
  MeasReviewer2Notes?: string;
  MeasManagerDecision?: number;
  MeasManagerNotes?: string;
  EunitDecision?: number;
  EunitNotes?: string;
  EunitSignedUsersCount?: number;
  DeputyManagerSigned?: number;
  ManagerSigned?: number;
  IsDeleted: boolean;
  BaseRequest?: BaseRequest;
}

export class ReleaseRefundAdminDTO {
  Id: string; // Guid
  ReleaseRequestId: string; // Guid
  AdminEmail: string;
  WFNextUsers: string[];
  MeasReviewer1Decision?: number;
  MeasReviewer1Notes?: string;
  MeasReviewer2Decision?: number;
  MeasReviewer2Notes?: string;
  MeasManagerDecision?: number;
  MeasManagerNotes?: string;
  EunitDecision?: number;
  EunitNotes?: string;
  EunitSignedUsersCount?: number;
  ProceedToManagers?: boolean;
  DeputyManagerSigned?: number;
  ManagerSigned?: number;
  MeasurementPrinted?: boolean;
  BaseRequest?: BaseRequest;
}
export class ReleaseRestudyAdminDTO {
  Id: string; // Guid
  ReleaseRequestId: string; // Guid
  AdminEmail: string;
  WFNextUsers: string[];
  MeasReviewerDecision?: number;
  MeasReviewerNotes?: string;
  MeasReviewer2Decision?: number;
  MeasReviewer2Notes?: string;
  MeasManagerDecision?: number;
  MeasManagerNotes?: string;
  EunitRegistersDecision?: number;
  EunitRegisterNotes?: string;
  EunitModifyRebateNote?: string;
  EunitApproveDecision?: number;
  EunitApproveNotes?: string;
  MeasCreatorCancelationFromula?: string;
  MeasManagerCanceledRbateNote?: string;
  MeasReviewerCanceledRbateNote?:string;
  MeasReviewerCanceledRbateDecision?: number;
  MeasManagerCanceledRbateDecision?: number;
  EunitSignedUsersCount?: number;
  ProceedToManagers?: boolean;
  DeputyManagerSigned?: number;
  ManagerSigned?: number;
  EunitSignedUsersNo?:number;
  MeasurementPrinted?: boolean;
  BaseRequest?: BaseRequest;
  Attachments:Attachment[]= [];
}

export class ReleaseWFSubmittedAdminsDTO
{
  Id: string;
  BaseRequestId: string;
  StepName: string;
  UserEmail: string;
  Role: number;
  order: number;
}

export class LongHaulRequest {
  RequestorEmail: string;
  Id: string;
  OperatorName: string;
  OperatorEmail: string;
  VesselName: string;
  VesselTypeId: Number;
  ExNames: string;
  YearBuilt: string;
  CallSign: string;
  IMONo: string;
  DWT: string;
  SCNT: string;
  LastTransitDate: string;
  LPGLNGCapacity: string;
  ReeferCapacity: string;
  MAXDraught: string;
  TRNDraught: string;
  Beam: string;
  DesignSpeed: string;
  FuelIFO: string;
  FuelDO: string;
  CargoKind: string;
  CargoQuantity: string;
  TPITPC: string;
  Name: string;
  EMail: string;
  Fax: string;
  InternalStatusId?: number;
  ExternalStatusId?: number;
  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
  IsEditable: boolean;
  IsRestudy: boolean;
  RebateFileNumber: string;
  RebateStatusId: number;
  IsShipPassed: boolean;
  CancelationReason: string;
  CancelationMessage: string;
  RequestorId: string;
  ServiceId: number;
  StatusId: number;
  LongHaulRequestOptions: LongHaulRequestOption[];
  LongHaulRequestEconomicCommittee: LongHaulRequestEconomicCommittee;
  LongHaulRequestMeasurementCommittee: LongHaulRequestMeasurementCommittee;
  BaseRequest: BaseRequest;
  RequireModificationRecentComment: LongHaulComment;
  Status1: Status;
  CanClone: boolean;
  IsSubmitClone: boolean;
  IsSubRequest: boolean;
  IsShipLoaded: boolean;
  IsScrubberFitted: boolean | null;
  MainEngineFuelId: number | null;
  OtherMainEngineFuel: string;
  ParentRequestNumber: string;

  CanPerformAcurateDataForm: boolean = false;
  CanPerformAdminActions: boolean = false;
  LastTransitDateString: string;
  RebateNote: string;
};

export class LongHaulRequestOption {
  Id: string;
  LongHaulRequestId: string;
  ActualSpeed: string;
  LastCountryOriginId: number;
  LastPortOriginId: number | null;
  FirstCountryDestinationId: number;
  FirstPortDestinationId: number | null;
  DirectionId: number;
  DistanceMilesSuez: string;
  DistanceMilesPanama: string;
  DiffInDistance: string;
  WhetherSuez: string;
  WhetherPanama: string;
  DurationSuez: string;
  DurationPanama: string;
  AntiPiracyCostSuez: string;
  AntiPiracyCostPanama: string;
  IFOTon: string;
  IFOTonPrice: string;
  DOTon: string;
  DOTonPrice: string;
  DailyTimeCharter: string;
  SCTolls: string;
  SCOtherCharges: string;
  PanamaTolls: string;
  PanamaOtherCharges: string;
  CargoSuezTon: string;
  CargoPanamaTon: string;
  FreightPerTon: string;
  CargoLostValue: string;
  TotalCostSuez: string;
  TotalCostPanama: string;
  DiffInCost: string;
  SuggestedRebate: string;
  NumericSuggestedRebate: number;
  RebatePercentage: string;
  RebatePercentageLetters: string;
  RebatePercentageReviewDecision: string;
  RebatePercentageReviewDecisionValue: string;
  DateOfSailing: string;
  ETA: string;

  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
  IsShipUsed: boolean;
  PassingDate: string;
  EconomicCommiteeDefineRebateNotes: string;
  MeasurementCommiteeReviewRebateNotes: string;
  IsOptionAdminDone: boolean = false;
  IsUpdatePercentageEnabled: boolean = false;
  IsOptionDeleted: boolean = false;
  ReviewRebateMode: number;
  OtherLastPortOrigin: string;
  OtherFirstPortDestination: string;
  DisplayedDefinedRebate: string;
  SailDirection: SailDirection;
};

export class LongHaulRequestEconomicCommittee {
  Id: string;
  IsReceived: boolean;
  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
  DecisionId: number | null;
  FormulatedDecision: string;
};

export class LongHaulRequestMeasurementCommittee {
  Id: string;
  DecisionId: number | null;
  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
  RejectionReason: string;
};

export class LongHaulComment {
  Id: string;
  LongHaulRequestId: string;
  CommentTypeId: number;
  Comment: string;
  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
  CommenterTypeId: number;
};

export class LongHaulRequestMeasurementCommitteeDecision {
  DecisionId: number;
  LongHaulRequestMeasurementCommitteeAccept: LongHaulRequestMeasurementCommitteeAccept;
  RequireModificationNotesAndComments: string;
  RejectionReason: string;
};

export class LongHaulRequestMeasurementCommitteeAccept {
  Id: string;
  SCID: string;
  LastTransitDate: string;
  RebateOnlastTransit: boolean;
  RebateValue: string;
  PortOfOrigin: string;
  PortOfDestination: string;
  SCNT: string;
  DW: string;
  DirectionId: number;
  NumberOfTugs: string;
  RateId: number;
  VesselTypeId: number | null;
  ExtraCost: string;
  NotesAndComments: string;
  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
  TugsLongHaulRequestMeasurementCommitteeDecisionAccept: TugsLongHaulRequestMeasurementCommitteeDecisionAccept[];
};

export class TugsLongHaulRequestMeasurementCommitteeDecisionAccept {
  LongHaulRequestMeasurementCommitteeAcceptId: string;
  TugId: number;
  NumberOfTugs: number;
  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
  TugNameEN: string;
};

export class OptionKey {
  Index: number;
  Text: string;
  Value: number;
  Port: string;
};

//Define Rebate Component DTO
export class LongHaulDefineRebate {
  LongHaulRequestId: string;
  DecisionId: number;
  LongHaulOptionsRebate: LongHaulOptionRebate[];
  StandardMessage: string;
  EconomicCommitteeAdminEmail: string;
};

export class LongHaulOptionRebate {
  Id: string;
  RebatePercentage: string;
  Notes: string;
  MeasurementDecisionId: number | null;
  MeasurementRejectionReason: string;
  CreationDate: string;
};
export class Diff {
  Id: string;
  Field: string;
  Formula: string;
  NewData: string
};

//Confirm Receiving Request Component DTO
export class AknowledgeReceiveRequest {
  LongHaulRequestId: string;
  EconomicCommitteeAdminEmail: string;
  CommenterType: CommenterType;
}

export enum CommenterType {
  MeasurementCommittee = 1,
  EconomicCommittee = 2,
}

//Review Rebate Component DTO
export class LongHaulReviewRebate {
  LongHaulRequestId: string;
  LongHaulOptionsRebateReview: LongHaulOptionRebateReview[] = [];
  WorkFlowResponse: number;
  MeasurementCommitteeAdminEmail: string;
};

export class LongHaulOptionRebateReview {
  Id: string;
  DecisionId: number;
  Notes: string;
  IsOptionDone: boolean = false;
};

//Formulated Approved Decision Component DTO
export class LongHaulRequestFormulateDecision {
  LongHaulRequestId: string;
  CurrentDate: string;
  ModifiedDate: string;
  LongHaulRequestOptionsFormulatedDecision: LongHaulRequestOptionFormulatedDecision[] = [];
  FormulatedDecision: string;
  AdminEmail: string;
  // Requestor Decision Component
  DecisionId: number = 0;
  Notes: string;
  RequestorEmail: string;
  SelectedOptionId: string;
  // Custom Property
  IsFormulatedDecisionComponent: boolean;
};

export class LongHaulRequestOptionFormulatedDecision {
  Id: string;
  FirstPortOfDestination: string;
  LastPortOfOrigin: string;
  RebatePercentage: string;
  RebatePercentageLetters: string;
  // Requestor Decision Component
  IsSelected: boolean;
  RequestedRebate: number;
  EconomicCommitteeNotes: string;
  IsShowMoreEnabled: boolean;
};

//Accurate Data Form Component
export class LongHaulRequestAccurateDataForm {
  Id: string;
  DateOfSailing: string;
  PortOfOrigin: string;
  PortOfDestination: string;
  SCNT: string;
  VesselTypeId: number | null;
  Cargo: string;
  OtherCharges: string;
  Deadweight: string;
  NoOfEscTugs: number | null;
  NoOfImposedTugs: number | null;
  Remarks: string;
  RateId: string;
  CreatedBy: string;
  CreationDate: string;
  ModifiedBy: string;
  ModifiedDate: string;
  IsDeleted: boolean;
};

//Mark Request Refunded Component
export class LongHaulRequestMarkRefunded {
  Id: string;
  IsRefunded: boolean;
  IsClosed: boolean;
  AdminEmail: string;
};

//Confirm Ship Passing Component
export class LongHaulRequestConfirmShipPassing {
  LongHaulRequestId: string;
  LongHaulRequestOptionId: string;
  IsShipPassed: boolean;
  IsShipPassedString: string;
  PassingDate: Date;
  TimeZoneOffset: number;
  GrantedRebatePercentage: number;
  IsRequestClosed: boolean;
  IsFormSubmitted: boolean;
  AdminEmail: string;
};

//Release Rebate Component
export class LongHaulRequestReleaseRebate {
  LongHaulRequestId: string;
  LongHaulRequestReleaseRebateOptions: LongHaulRequestReleaseRebateOption[] = [];
  ReleaseRebateMessage: string;
  IsRebateReleased: boolean;
  AdminEmail: string;
};

export class LongHaulRequestReleaseRebateOption {
  Id: string;
  FirstPortOfDestination: string;
  LastPortOfOrigin: string;
  RebatePercentageNumbers: number;
  RebatePercentageLetters: string;
  IsOptionAdminDone: boolean = false;
  DecisionId: number;
  DecisionIdString: string;
  UpdatedRebatePercentage: number;
  CancelationReason: string;
};


export class ArabicNames {
  NameEN: string;
  NameAR: string;
  Email: string;
  JobNumber: number;
  TYPE: string;
};
